import React from "react";
import {useDispatch, connect} from 'react-redux';
import { Paper } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CloseIcon from '@mui/icons-material/Close';


const mapStateToProps = (state) => {
    return {
        map: state.MapReducer
    }
}

const LegendPanel = (props) => {
    const dispatch = useDispatch();

    const [showPanel, setShowPanel] = React.useState(true);
    const [unit, setUnit] = React.useState();
    const [comment, setComment] = React.useState();
    
    React.useEffect(()=>{
        if(props.map.activeLayer.includes("kulonb")||props.map.activeLayer.includes("grid")) {
            setComment("(warmer colour=more developed)");
            setUnit("Decile");
        } else {
            setComment("");
            setUnit("");
        }
    })

    return <div>
    {
        !showPanel?(
            <IconButton style={{color: 'gray'}} onClick={()=>{setShowPanel(true)}} aria-label="delete">
                <ListAltIcon />
            </IconButton>):''
    }

    <Paper elevation={10} style={{padding: 10, minWidth: 150, display:showPanel?'block':'none', paddingLeft: 16, maxHeight: 'calc(100vh - 90px)', overflowY: 'auto', borderRadius:10, backgroundColor:'#f0f0f0'}}>
                        <IconButton style={{color:'gray', float:'right', marginRight:-8, marginTop:-8}} onClick={()=>{setShowPanel(false)}} aria-label="delete">
                            <CloseIcon style={{width:20}} />
                        </IconButton>

        <span style={{fontWeight:'bold', fontSize:16}}>Legend</span>
        <hr />
        <div style={{fontStyle:'italic', fontSize:12, paddingBottom:0}}>{comment}</div>
        <div style={{fontStyle:'italic', paddingBottom:0}}>{unit}</div>
        {
            props.map.styleData.breaks.map((style, idx)=>{
                return <div key={style.name}>
                    <span style={{background: style.color, borderRadius: 2}}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;
                    {
                        `${style.name}`.replaceAll("_"," ")
                    }
                </div>
            })
        }
    </Paper>
    </div>
}

export default connect(mapStateToProps)(LegendPanel);